import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Geolocation from "../Geolocation/index.js";
import * as Restaumatic$dAnalytics$dTypes$dEvent from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic$dEnvironment from "../Restaumatic.Environment/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dOldStorage from "../Restaumatic.OldStorage/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dServices$dGeocoding$dReverse from "../Restaumatic.Services.Geocoding.Reverse/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic$dSite$dComponents$dAddress from "../Restaumatic.Site.Components.Address/index.js";
import * as Restaumatic$dSite$dComponents$dDeliveryAddress$dStorage from "../Restaumatic.Site.Components.DeliveryAddress.Storage/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic$dSite$dUI from "../Restaumatic.Site.UI/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dTracking from "../Utils.Tracking/index.js";
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const readStoredValue = /* #__PURE__ */ Restaumatic$dOldStorage.readStoredValue(Foreign$dGeneric$dClass.intDecode)()(Specular$dDom$dBuilder.monadReaderBuilder)(Specular$dInternal$dRIO.monadEffectRIO);
const streetNumberIsSymbol = {reflectSymbol: () => "streetNumber"};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const streetIsSymbol = {reflectSymbol: () => "street"};
const postCodeIsSymbol = {reflectSymbol: () => "postCode"};
const cityIsSymbol = {reflectSymbol: () => "city"};
const readStoredValue1 = /* #__PURE__ */ (() => Restaumatic$dOldStorage.readStoredValue({
  decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(postCodeIsSymbol)(decodeWithOptionsOther)())(cityIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
})()(Specular$dDom$dBuilder.monadReaderBuilder)(Specular$dInternal$dRIO.monadEffectRIO))();
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const storeValue = /* #__PURE__ */ (() => Restaumatic$dOldStorage.storeValue({
  encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(postCodeIsSymbol)(encodeWithOptionsOther))(cityIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
})()(Specular$dDom$dBuilder.monadReaderBuilder)(monadFRP))();
const asyncRequestMaybe = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequestMaybe(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP);
const identity = x => x;
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const performEvent = /* #__PURE__ */ Specular$dFRP$dAsync.performEvent(monadFRP);
const geocodingStatus = displayEmptyMessage => dresult => {
  const geocodingError = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-danger", "js-geocoding-errors"])])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.geocoding_error),
    {}
  )));
  return dynamic_(Specular$dFRP$dBase.functorDynamic.map(result => {
    if (result.tag === "NotRequested") {
      const $0 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-info", "u-mb0"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("icon-info-sign"),
        Specular$dDom$dElement.attr("aria-hidden")("true")
      ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.enter_address),
        {}
      ))));
      if (displayEmptyMessage) { return $0; }
      return Specular$dInternal$dRIO.pureImpl();
    }
    if (result.tag === "Loading") {
      return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("js-geocoding-in-progress")])(Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dUI.spinnerIconExtra(""))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery.geocoding),
        {}
      ))));
    }
    if (result.tag === "Loaded") {
      if (result._1.tag === "Left") { return geocodingError; }
      if (result._1.tag === "Right") {
        if (result._1._1.tag === "Nothing") { return geocodingError; }
        if (result._1._1.tag === "Just") { return Restaumatic$dPrelude$dSpecular.wempty; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  })(dresult));
};
const deliveryAddressWidget = config => Specular$dInternal$dRIO.bindImpl(readStoredValue("client_storageFormatVersion"))(v => Specular$dInternal$dRIO.bindImpl((() => {
  const $0 = (() => {
    if (v.tag === "Nothing") { return false; }
    if (v.tag === "Just") { return true; }
    $runtime.fail();
  })();
  const $1 = Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2("client_storageFormatVersion")(Foreign$dInternal$dStringify.unsafeStringify(1));
  if (!$0) { return $1; }
  if ($0) { return Specular$dInternal$dRIO.pureImpl(); }
  $runtime.fail();
})())(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v2 => {
  if (v2.tag === "Nothing") { return Restaumatic$dSite$dComponents$dAddress.emptyRawDeliveryAddress; }
  if (v2.tag === "Just") { return v2._1; }
  $runtime.fail();
})(Specular$dInternal$dRIO.mapImpl(Data$dMaybe.functorMaybe.map(Restaumatic$dSite$dComponents$dDeliveryAddress$dStorage.fromStoredDeliveryAddress))(readStoredValue1("client_street_address"))))(initialAddress => Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dAddress.addressWidget(config)(initialAddress))(v1 => {
  const $0 = v1.validAddress;
  return Specular$dInternal$dRIO.bindImpl(storeValue("client_street_address")(Specular$dFRP$dBase.functorEvent.map(Restaumatic$dSite$dComponents$dDeliveryAddress$dStorage.toStoredDeliveryAddress)(v1.rawAddress)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v2 => v2.geocoding)(Specular$dDom$dBuilder.monadAskBuilder.ask))(v2 => Specular$dInternal$dRIO.bindImpl(asyncRequestMaybe(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(Effect$dAff._map(m => {
    if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
    if (m.tag === "Right") { return Data$dEither.$Either("Right", m._1.location); }
    $runtime.fail();
  })))(Specular$dFRP$dBase.functorDynamic.map(v1$1 => {
    if (v1$1.tag === "Just") {
      return Data$dMaybe.$Maybe("Just", v2.geocodeAddress(v1$1._1.country)({street: v1$1._1.street, streetNumber: v1$1._1.streetNumber, city: v1$1._1.city}));
    }
    return Data$dMaybe.Nothing;
  })($0))))(v3 => Specular$dInternal$dRIO.pureImpl({
    address: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v4 => v5 => {
      if (v4.tag === "Just") {
        if (v5.tag === "Loaded") {
          if (v5._1.tag === "Right") {
            if (v5._1._1.tag === "Just") { return Data$dMaybe.$Maybe("Just", {address: v4._1, location: v5._1._1._1}); }
            return Data$dMaybe.Nothing;
          }
          return Data$dMaybe.Nothing;
        }
        return Data$dMaybe.Nothing;
      }
      return Data$dMaybe.Nothing;
    })($0))(v3),
    status: v3,
    addressWithoutLocation: $0
  }))));
}))));
const autolocatingDeliveryAddressWidget = config => Specular$dInternal$dRIO.bindImpl(newEvent)(v => {
  const $0 = v.fire;
  const $1 = v.event;
  return Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(isApp => isMobileGeolocationEnabled => isInIframe => isApp && !isMobileGeolocationEnabled || isInIframe)(Restaumatic$dEnvironment.isMobileApp))(Restaumatic$dEnvironment.isInIframe))(Restaumatic$dEnvironment.mobileGeolocationEnabled))(n => Specular$dInternal$dRIO.bindImpl((() => {
    const $2 = Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["form-group", "m-form__group", "u-full-width"]),
      Specular$dDom$dElement.classUnlessD(config.visible)("hide")
    ])(Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.class_("btn btn-link u-p0"),
      Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_($0)
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.attr("aria-hidden")("true"),
      Specular$dDom$dElement.classes(["icon-target", "u-font-size-120p"])
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.locate_me),
      {}
    )))));
    if (!n) { return $2; }
    if (n) { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  })())(() => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(v$1 => () => {
    const currency = Utils$dTracking.getCurrencyEff();
    return Utils$dTracking.trackEventEff(Utils$dTracking.toNamedEvent(currency)(Restaumatic$dAnalytics$dTypes$dEvent.LocateMe))();
  })($1))(() => Specular$dInternal$dRIO.bindImpl(performEvent((() => {
    const $2 = Geolocation.getCurrentPosition(Geolocation.defaultOptions);
    return Specular$dFRP$dBase.functorEvent.map(v$1 => $2)($1);
  })()))(locationCoordinates => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(reverseGeocodeResponse => Specular$dFRP$dBase.filterMapEvent(identity)(Specular$dFRP$dBase.functorEvent.map(x => {
    if (x.tag === "Left") { return Data$dMaybe.Nothing; }
    if (x.tag === "Right") { return x._1.streetAddress; }
    $runtime.fail();
  })(reverseGeocodeResponse)))(performEvent(Specular$dFRP$dBase.functorEvent.map(Restaumatic$dServices$dGeocoding$dReverse.reverseGeocode(config.restaurantId))(locationCoordinates))))(geocodeStreetAddress => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-delivery-address__container"),
    Specular$dDom$dElement.classUnlessD(config.visible)("hide")
  ])(deliveryAddressWidget({
    withAptInfo: config.withAptInfo,
    country: config.country,
    accountId: config.accountId,
    restaurantId: config.restaurantId,
    geocodingAddressE: geocodeStreetAddress
  })))(addressWidget => Specular$dInternal$dRIO.bindImpl((() => {
    const $2 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-delivery-address__status"), Specular$dDom$dElement.classUnlessD(config.visible)("hide")])(geocodingStatus(config.withEmptyMessage)(addressWidget.status));
    return env => {
      const $3 = {...env, userEnv: undefined};
      return $2($3);
    };
  })())(() => Specular$dInternal$dRIO.pureImpl({address: addressWidget.address, addressWithoutLocation: addressWidget.addressWithoutLocation}))))))));
});
export {
  asyncRequestMaybe,
  autolocatingDeliveryAddressWidget,
  cityIsSymbol,
  decodeWithOptionsOther,
  deliveryAddressWidget,
  dynamic_,
  encodeWithOptionsOther,
  geocodingStatus,
  identity,
  monadFRP,
  newEvent,
  performEvent,
  postCodeIsSymbol,
  readStoredValue,
  readStoredValue1,
  storeValue,
  streetIsSymbol,
  streetNumberIsSymbol,
  subscribeEvent_
};
